import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import a1 from "../Accests/images/beach/IMG-20250630-WA0023.jpg";
import a2 from "../Accests/images/bonfire/IMG-20250630-WA0016.jpg";
import a3 from "../Accests/images/instumrnt/IMG-20250702-WA0004.jpg";
import a4 from "../Accests/images/dj/IMG-20250630-WA0013.jpg";
import a5 from "../Accests/images/Fireworks/bo.avif";
import BottomActionBar from "./BottomActionBar";

const activities = [
    {
        title: "Beach Party",
        description:
            "Join us for a vibrant beach party filled with fun activities, music, and stunning views.",
        image: a1,
        tags: ["#beach", "#party", "#fun"],
        route: "/beach-party",
    },
    {
        title: "Bonfire",
        description:
            "Often lit during festivals or special occasions, these bonfires symbolize joy, renewal, or the driving away of evil spirits.",
        image: a2,
        tags: ["#bonfire", "#night", "#display"],
        route: "/bonfire",
    },
    {
        title: "Instrumental Music",
        description:
            "Relax to the soothing sounds of live instrumental music performances.",
        image: a3,
        tags: ["#music", "#live", "#relax"],
        route: "/instrumental-music",
    },
    {
        title: "DJ Music",
        description:
            "Dance the night away with electrifying beats from our talented DJs.",
        image: a4,
        tags: ["#dj", "#dance", "#music"],
        route: "/dj-music",
    },
    {
        title: "Fireworks Display",
        description:
            "Witness an amazing fireworks display that will leave you in awe.",
        image: a5,
        tags: ["#fireworks", "#amazing", "#show"],
        route: "/fireworks",
    },
];

const OurActivity = () => {
    const [showActionBar, setShowActionBar] = useState(true);
    const navigate = useNavigate();
    let lastScrollY = window.scrollY;

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;
            setShowActionBar(currentScrollY < lastScrollY);
            lastScrollY = currentScrollY;
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <>
            <BottomActionBar visible={showActionBar} />

            <div
                data-aos="zoom-in"
                className="flex flex-col items-center justify-center py-8 bg-gray-100 mt-24 md:mt-16 lg:mt-10"
            >
                <h2 className="text-3xl font-bold mb-6 text-center">Our Activities</h2>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 px-4">
                    {activities.map((activity, index) => (
                        <div
                            key={index}
                            className="cursor-pointer max-w-sm rounded overflow-hidden shadow-lg bg-white hover:shadow-xl transition-shadow duration-300"
                            onClick={() => navigate(activity.route)}
                        >
                            <img
                                className="w-full h-56 object-cover"
                                src={activity.image}
                                alt={activity.title}
                            />
                            <div className="px-6 py-4">
                                <div className="font-bold text-xl mb-2">{activity.title}</div>
                                <p className="text-gray-700 text-base">{activity.description}</p>
                            </div>
                            <div className="px-6 py-4">
                                {activity.tags.map((tag, idx) => (
                                    <span
                                        key={idx}
                                        className="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2"
                                    >
                    {tag}
                  </span>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

export default OurActivity;
